import { Accessibility, BadgeCheck, Baby, Dna, Globe2, Hourglass, Landmark, Scale, Users } from 'lucide-react';

export const MODULE_ICONS = { Hourglass, Globe2, Users, Baby, Landmark, Accessibility, Dna, BadgeCheck };
export const moduleIcon = (name) => MODULE_ICONS[name] || Scale;

export const scoreTone = (score, passing) => {
    if (score === null || score === undefined) return 'text-muted-foreground';
    return score >= passing ? 'text-emerald-600' : 'text-red-600';
};

export const formatDateTime = (iso) =>
    iso ? new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-';
